import React from 'react'
import styled from 'styled-components'
import { AppStoreIcon, GooglePlayIcon, HomePageImg } from '../utils/Images'

const Home = () => {
    return (
        <HomeWrapper>
            <img src={HomePageImg} alt="" className='bg-img' />
            <div className='content-div'>
                <h1>Download the mobile app</h1>
                <h1>to access all the features</h1>
                <div className='btn-div'>
                    <img src={GooglePlayIcon} alt="" />
                    <img src={AppStoreIcon} alt="" />
                </div>
            </div>
        </HomeWrapper>
    )
}

export default Home

const HomeWrapper = styled.div`
    height:100vh;
    display:flex;
    align-items:center;
    justify-content:center;
    position:relative;
    .bg-img{
        width:100%;
        height:100%;
        object-fit:cover;
        position:relative;
    }
    .content-div{
        position:absolute;
        width:100%;
        display:flex;
        flex-direction:column;
        justify-content:center;
        align-items:center;
        h1{
            font-weight:700;
            font-size:56px;
            color:#fff;

            @media (max-width: 760px){
                font-size:48px;
            }
            @media (max-width: 600px){
                font-size:38px;
            }
            @media (max-width: 475px){
                font-size:30px;
            }
        }
        .btn-div{
            margin-top:82px;
            display:flex;
            gap:13px;
            img{
                width:211px;
                height:61px;
                cursor:pointer;

                @media (max-width: 760px){
                    width:170px;
                    height:48px;
                }
                @media (max-width: 760px){
                    width:150px;
                    height:40px;
                }
            }
        }
    }
`